module.exports = __webpack_public_path__ + "img/9.7f1c443b.png";